import useAPI from '@/pages/members/hooks/useAPI';
import AuthRepository from '@/repositories/members/AuthRepository';

export const useGetOneTimeToken = ({ enabled = false }: { enabled?: boolean }) => {
  const authRepository = AuthRepository();

  return useAPI({
    queryKey: ['getOneTimeToken'],
    queryFn: authRepository.getOneTimeToken,
    refetchOnWindowFocus: false,
    enabled: enabled
  });
};
